<template>
  <q-page padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">
        Ativar controle de Lote
        <q-icon
          style="cursor: pointer"
          name="info"
          @click="activeSlide = !activeSlide"
        />
      </p>
    </div>
    <infot-upload
      :activeSlide="activeSlide"
      :link="'https://multpex-docs.s3.amazonaws.com/templates/estoque/template_ativar_controle_estoque_r1.xlsx'"
      :infos="infos"
    />

    <div class="row items-center q-mt-md">
      <div class="col-2">
        <q-file label="Selecione o Template" outlined dense v-model="file">
          <template v-slot:prepend>
            <q-icon name="attach_file" />
          </template>
        </q-file>
      </div>

      <div class="col-2">
        <q-btn
          color="positive"
          class="q-ml-sm"
          icon="add"
          no-caps
          label="Enviar Template"
          @click="enviarTemplate"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
import { ref } from "@vue/reactivity";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import InfotUpload from "../../compras/components/InfotUpload.vue";
export default {
  components: { InfotUpload },
  setup() {
    const quasar = useQuasar();
    const store = useStore();
    const file = ref("");
    const activeSlide = ref(false);
    const infos = ref([
      {
        name: "Para esse serviço é ncessário somente o código do Item",
        icon: "do_not_disturb",
      },
      {
        name: "Não crie nenhuma outra coluna",
        icon: "delete",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação",
        icon: "view_column",
      },
    ]);

    const enviarTemplate = async () => {
      if (file.value == "" || file.value.name.indexOf("xlsx") == -1) {
        quasar.notify({
          message: "O tipo do arquivo não e aceito, ou o campo esta vazio",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }

      try {
        var reader = new FileReader();
        reader.readAsDataURL(file.value);
        reader.onload = async function () {
          try {
            await store.dispatch("estoque/upload", {
              planilha: reader.result,
              mapeamento: "ativacao_lote",
              adicional: { vendor_id: store.state.org.unidadeData.id },
            });

            quasar.notify({
              message: "Enviado com sucesso",
              color: "positive",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
          } catch (error) {
            quasar.notify({
              message: "Erro a o enviar",
              color: "negative",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
          }
        };

        file.value = "";
      } catch (error) {
        console.log(error);

        file.value = "";
      }
    };

    return {
      enviarTemplate,
      file,
      activeSlide,
      infos,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
